module.exports = __webpack_public_path__ + "img/voucher_ori_a4.4f88ca8b.png";